import { z } from 'zod';
import { calendarEventSchema } from './ICalendarEvent';
import { calendarEventAttendeeFormSchema } from './ICalendarEventAttendeeForm';

// This is only used for the form
export const calendarEventFormSchema = calendarEventSchema
  .omit({ attendees: true })
  .merge(
    z.object({
      requiredAttendees: z.array(calendarEventAttendeeFormSchema),
      optionalAttendees: z.array(calendarEventAttendeeFormSchema),
    })
  );

export type ICalendarEventForm = z.infer<typeof calendarEventFormSchema>;
